export default {
  mapboxToken: process.env.VUE_APP_MAPBOX_TOKEN,
  mapStyles: {
    default: "mapbox://styles/mapbox/streets-v10",
    light: "mapbox://styles/mapbox/light-v9"
  },
  defaultMapCenter: {
    lat: 52.2489034,
    lon: 6.1284188
  },
  defaultMapZoom: 4,
  trackerApiBaseUrl: `https://api.iotracker.nl/v1/devices`,
  trackerApiToken: process.env.VUE_APP_IOTTRACKER_TOKEN,
  orionBaseUrl: `https://orion.smartenschede.nl/v2/`,
  sqlConduitUrl: "https://data.smartenschede.nl/",
  postgresAuth: {
    username: process.env.VUE_APP_POSTGRES_USERNAME,
    password: process.env.VUE_APP_POSTGRES_PASSWORD
  },
  metricwireBaseUrl: `https://consumer-api.metricwire.com`,
  metricwireHTBWorkspaceId: "5d020521e21505760d890231",
  dashboardLocations: [
    {
      name: "Amersfoort",
      location: {
        lat: 52.15732235854415,
        lng: 5.39080726697307
      }
    },
    {
      name: "Deventer",
      location: {
        lat: 52.25162893885428,
        lng: 6.157999829406071
      }
    },
    {
      name: "Enschede",
      location: {
        lat: 52.220039159705834,
        lng: 6.895935746580875
      }
    },
    {
      name: "Zwolle",
      location: {
        lat: 52.512321,
        lng: 6.091537
      }
    }
  ]
};
